/** 支持中文正文紧接 @；邮箱、重复 @ 和已经完成的正文不触发。 */
export function workflowMentionQuery(value, caret = value.length) {
  const before = value.slice(0, caret);
  const match = before.match(/@([^\s@]*)$/u);
  if (!match) return null;
  const from = caret - match[1].length - 1;
  if (from > 0 && /[A-Za-z0-9.!#$%&'*+/=?^_`{|}~@-]/u.test(before[from - 1])) return null;
  return { from, to: caret, query: match[1] };
}
export function insertWorkflowMention(value, range, name, caret = value.length) {
  const from = range?.from ?? caret, to = range?.to ?? caret;
  const text = `@${name} `;
  return { value: value.slice(0, from) + text + value.slice(to), caret: from + text.length };
}

/** 编辑穿过已选择片段就取消该提醒；片段前的输入只平移位置，绝不靠同名文本猜用户。 */
export function reconcileWorkflowMentions(before, after, tokens = []) {
  let start = 0;
  while (start < before.length && start < after.length && before[start] === after[start]) start++;
  let end = before.length, nextEnd = after.length;
  while (end > start && nextEnd > start && before[end - 1] === after[nextEnd - 1]) { end--; nextEnd--; }
  const delta = after.length - before.length;
  return tokens.flatMap(token => {
    let next;
    if (token.to <= start) next = token;
    else if (token.from >= end) next = { ...token, from: token.from + delta, to: token.to + delta };
    else return [];
    return after.slice(next.from, next.to) === next.text ? [next] : [];
  });
}
export function workflowMentionPayload(value, tokens = []) {
  const selected = tokens.filter(t => value.slice(t.from, t.to) === t.text).map(t => t.mention);
  return [...new Map(selected.map(m => [JSON.stringify(m), m])).values()].sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
}
